import React from 'react';
import { isNum } from './chartUtils';
import './charts.css';

/** Tiny trend line over real, ordered numeric points. Needs 2+ points, otherwise renders nothing. */
const Sparkline = ({ points, label, width = 120, height = 32, testId }) => {
  const pts = (points || []).filter(isNum);
  if (pts.length < 2) return null;
  const lo = Math.min(...pts);
  const hi = Math.max(...pts);
  const span = hi - lo || 1;
  const step = (width - 4) / (pts.length - 1);
  const xy = pts.map((p, i) => [2 + i * step, height - 3 - ((p - lo) / span) * (height - 6)]);
  const aria = `${label || 'Trend'}: from ${pts[0]} to ${pts[pts.length - 1]} over ${pts.length} points`;
  const last = xy[xy.length - 1];
  return (
    <svg className="pl-chart" role="img" aria-label={aria} viewBox={`0 0 ${width} ${height}`} width={width} height={height} data-testid={testId}>
      <title>{aria}</title>
      <desc>Sparkline trend.</desc>
      <polyline points={xy.map((p) => p.join(',')).join(' ')} fill="none" stroke="var(--chart-1)" strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
      <circle cx={last[0]} cy={last[1]} r="3" fill="var(--chart-1)" stroke="var(--color-bg-white)" strokeWidth="2" />
    </svg>
  );
};

export default Sparkline;
